@for (signalConfig of gatewaySignals; track signalConfig) {
  <div>
    <div class="card card-default mb-2">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col">
            <strong class="h5 card-title" [innerText]="signalConfig.typeOfData"></strong>
          </div>
          <div class="col-auto">
            <div class="pull-right" role="group" aria-label="...">
              <button type="button" class="btn btn-primary btn-sm"
                (click)="onAddArray(signalConfig)"
                [disabled]="!superOrTechAdminRole || !isEditable">
                <span class="fa-solid fa-plus"></span><span class="hidden-xs" translate>New array</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="card">
          <div class="card-body">
            <table class="table vertical-align-middle mb-0">
              <thead>
                <tr>
                  <th translate>Name</th>
                  <th translate>Type</th>
                  <th translate>Values</th>
                  <th class="text-right" translate>Action</th>
                </tr>
              </thead>
              <tbody>
                @for (array of signalConfig.arrays; track array) {
                  <tr>
                    <td>
                      <b [innerText]="array.name"></b>
                    </td>
                    <td><span class="badge badge-pill badge-info" [innerText]="array.datatype"></span></td>
                    <td>
                      @for (signal of array.values; track signal) {
                        <span class="badge badge-pill badge-dark ml-2"
                        [innerText]="signal.name"></span>
                      }
                    </td>
                    <td class="text-right">
                      <button type="button"
                        [disabled]="!superOrTechAdminRole || !isEditable"
                        aria-controls="collapseTabs" class="btn btn-sm btn-outline-primary"
                        (click)="onEditArray(signalConfig, array);"
                        title="{{'Edit Array' | translate}}">
                        <span class="fa-solid fa-pen"></span>
                      </button>
                      <button type="button" class="btn btn-sm btn-outline-danger ml-1"
                        (click)="onRemoveArray(signalConfig, array)"
                        title="{{'Remove array' | translate}}" [disabled]="!superOrTechAdminRole || !isEditable">
                        <span class="fa-solid fa-trash"></span>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
}